<template>
  <el-drawer
    title="编辑"
    append-to-body
    direction="rtl"
    :size="400"
    :modal="false"
    :visible.sync="showPanel"
    :before-close="handlePanelClose"
  >
    <div class="container">
      <div class="dimension-list">
        <el-form label-width="60px">
          <el-form-item label="切换" v-if="isShowTabs">
            <el-select v-model="filterTabKey" @change="handleChangeType">
              <el-option v-for="item in tabs" :key="item.key" :label="item.label" :value="item.key"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-for="(item, index) in dimensionIndicator" :key="index" :label="'维度' + (index + 1)">
            <el-input v-model="dimensionIndicator[index].name" placeholder="名称" style="width: 120px;"></el-input>
            &nbsp;&nbsp;&nbsp;
            <el-input-number
              v-model="dimensionList[0].value[index]"
              :min="0"
              :max="10"
              controls-position="right"
              placeholder="值"
              style="width: 120px;"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div class="add-item" @click="handleOk">
        确定
      </div>
      <div class="add-tips">
        注：<br />
        1、请填写1-10之间的数值 <br />
        2、若不填写维度6则自动生成5维度雷达图
      </div>
    </div>
  </el-drawer>
</template>

<script>
export default {
  name: "WikiTabbarEditPanel",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isShowTabs: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showPanel: false,
      dimensionList: [],
      dimensionIndicator: [],
      filterTabKey: ""
    };
  },
  watch: {
    data: {
      handler(val) {
        console.log(val);
        this.dimensionList = JSON.parse(JSON.stringify(val.radarData));
        this.dimensionIndicator = JSON.parse(JSON.stringify(val.radarIndicator));
        this.filterTabKey = val.filterTabKey;
      },
      immediate: true
    }
  },
  mounted() {},

  methods: {
    open() {
      this.showPanel = true;
    },
    handlePanelClose() {
      this.showPanel = false;
    },

    handleOk() {
      let notNameIndex = -1;
      let nameLength = 0;
      for (let i = 0; i < this.dimensionIndicator.length; i++) {
        const item = this.dimensionIndicator[i];
        if (i < 5) {
          if (!item.name) {
            notNameIndex = i;
            break;
          } else if (item.name && item.name.length > 10) {
            notNameIndex = i;
            nameLength = item.name.length;
            break;
          }
        }
      }
      if (nameLength > 10 && notNameIndex !== -1) {
        this.$message.error(`维度${notNameIndex + 1}名称不能超过10个字符`);
        return;
      }
      if (notNameIndex !== -1) {
        this.$message.error(`请填写维度${notNameIndex + 1}名称`);
        return;
      }

      this.data.radarData = this.dimensionList;
      this.data.radarIndicator = this.dimensionIndicator;
      const data = JSON.parse(JSON.stringify(this.data));
      this.$emit("onChange", data);
    },
    handleChangeType() {
      this.$emit("onChange", {
        ...this.data,
        filterTabKey: this.filterTabKey
      });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding: 20px;
  .tab-list {
    .tab-item {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      border: 1px solid #e3e3e3;
      padding: 4px 8px;
      margin-bottom: 10px;
      padding-right: 70px;
      .tab-icon {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        box-shadow: 0px 0px 3px 0px rgba(207, 207, 207, 0.29);
        border-radius: 4px;
        border: 1px solid #cacaca;
        margin-right: 12px;
        .img {
          position: relative;
          width: 100%;
          height: 100%;
          &:hover {
            .opreate-wrapper {
              display: flex;
            }
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
          .opreate-wrapper {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            display: none;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .icon {
              display: inline-block;
              width: 14px;
              height: 14px;
            }
          }
        }
        .upload-icon {
          width: 100%;
          height: 100%;
          font-size: 14px;
          text-align: center;
          line-height: 24px;
          color: #666;
        }
      }

      input {
        border: 1px solid #666;
        height: 24px;
      }
    }
  }
  .add-item {
    width: 100%;
    height: 36px;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    color: #555;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    .icon {
      margin-right: 10px;
    }
  }
  .add-tips {
    margin-top: 30px;
    font-size: 12px;
    color: #666;
    line-height: 24px;
  }
}

.edit-btns {
  display: inline-flex;
  float: right;
  height: 20px;
  position: absolute;
  right: 6px;
  top: 6px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
